<div class="card-chart">
  <canvas baseChart
          height="250px"
          width="600px"
          [colors]="chartsData[0].backgroundColor"
          [datasets]="chartsData"
          [labels]="chartsData[0].labels"
          [options]="options"
          [legend]="useLegend"
          [chartType]="chartType"></canvas>

</div>
